<template>
  <div
    class="h-full relative overflow-hidden flex flex-col justify-center items-center"
  >
    <div class="w-full flex flex-row justify-center items-center mt-20">
      <div
        class="2xl:w-4/12 xl:w-5/12 lg:w-5/12 flex flex-col justify-center items-center"
      >
        <span
          class="w-504 h-3.5 text-center bg-vivid-pink font-mulish-bold text-white text-2 leading-2.2 tracking-wider flex items-center justify-center px-2"
          >2. Awakening Progress</span
        >
        <img
          class="mt-9 w-full"
          :src="`${imgPath}/SystemChanges/awakening_02.png`"
          alt="awakening"
        />
        <div class="w-full flex flex-row justify-center mt-5">
          <div class="w-6/12 flex flex-col justify-center items-center">
            <h3
              class="font-mulish-extra-bold text-very-pale-orange 2xl:text-2 xl:text-1.6 lg:text-1.4 leading-2.2 tracking-wider"
            >
              Succeeding Equipment
            </h3>
            <h3
              class="font-mulish-medium text-very-pale-orange 2xl:text-2 xl:text-1.6 lg:text-1.4 leading-2.2 tracking-wider"
            >
              Awakening Progress
            </h3>
          </div>
          <div class="w-6/12 flex flex-col justify-center items-center">
            <h3
              class="font-mulish-extra-bold text-very-pale-orange 2xl:text-2 xl:text-1.6 lg:text-1.4 leading-2.2 tracking-wider"
            >
              Failing Equipment
            </h3>
            <h3
              class="font-mulish-medium text-very-pale-orange 2xl:text-2 xl:text-1.6 lg:text-1.4 leading-2.2 tracking-wider"
            >
              Awakening Progress
            </h3>
          </div>
        </div>
      </div>
      <div
        class="2xl:ml-12 xl:ml-6 xl:w-4/12 lg:w-4/12 flex justify-center items-center"
      >
        <div
          class="flex justify-center items-center px-3 py-3 bg-white rounded-3xl"
        >
          <div
            class="h-full flex justify-center items-center bg-very-pale-orange rounded-2xl shadow-sc-box p-11"
          >
            <p
              class="w-full max-w-75 font-mulish-semibold 2xl:text-1.8 xl:text-1.6 lg:text-1.4 leading-2.2 text-very-dark-gray text-center px-4 py-4"
            >
              Success / failure proceeds in order from options 1 to 4. If an
              option fails, all of the next options will fail unconditionally.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
    }),
  },
};
</script>

<style></style>
